"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("antd/dist/antd.css");

require("./AlertComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AlertComponent = function AlertComponent(_ref) {
  var message = _ref.message,
      type = _ref.type,
      showIcon = _ref.showIcon,
      closable = _ref.closable;
  return /*#__PURE__*/_react["default"].createElement(_antd.Alert, {
    type: type || "success",
    message: message || "default",
    showIcon: showIcon || false,
    closable: closable || false
  });
};

var _default = AlertComponent;
exports["default"] = _default;